import './App.css';
import 'bootstrap/dist/js/bootstrap.js';
import 'bootstrap/dist/css/bootstrap.css';
import '../src/assest/style/component_css/Button.css'
import '../src/assest/style/component_css/Form.css'
import '../src/assest/style/data_table/DataTable.css'
import '../src/assest/style/pages_css/LoginPage.css'
import '../src/assest/style/pages_css/Navbar.css'
import '../src/assest/style/pages_css/Details.css'
import '../src/assest/style/pages_css/Dashboard.css'
import '../src/assest/style/pages_css/MachineDashboard.css'
import '../src/assest/style/pages_css/LoginPage.css'
import '../src/assest/style/pages_css/AddOrder.css'
import '../src/assest/style/pages_css/Layout.css'
import Login from './pages/login/Login';
import ProtectedRoutes from './ProtectedRoute';
import Dashboard from './pages/dashboard/Dashboard';
import 'react-toastify/dist/ReactToastify.css';
import { Navigate, Route, Routes } from 'react-router-dom';
import UserList from './pages/user/UserList';
import AddUser from './pages/user/AddUser';
import ConfigurationForm from './pages/toolling-configuration/ConfigurationForm';
import UploadFiles from './pages/report/UploadFiles';
import DepartmentList from './pages/master/department/DepartmentList';
import DesignationList from './pages/master/designation/DesignationList';
import { ToastContainer } from 'react-toastify';
import AddDepartment from './pages/master/department/AddDepartment';
import UpdateDepartment from './pages/master/department/UpdateDepartment';
import AddDesignation from './pages/master/designation/AddDesignation';
import UpdateDesigantion from './pages/master/designation/UpdateDesignation';
import UpdateUser from './pages/user/UpdateUser';
import DefectList from './pages/master/defects/DefectList';
import AddDefect from './pages/master/defects/AddDefects';
import UpdateDefect from './pages/master/defects/UpdateDefect';
import ConfigurationHistory from './pages/toolling-configuration/ConfigurationHistory';
import DashboardNew from './pages/dashboard/DashboardNew';
import ActivityLogList from './pages/activity-log/ActivityLogList';
import SmartOfficeDashboard from './pages/dashboard/SmartOfficeDashboard';
import UpdateVersionForm from './component/form/master/version/UpdateVersion';
import ReasonList from './pages/master/reason/ReasonList';
import AddReason from './pages/master/reason/AddReason';
import UpdateReason from './pages/master/reason/UpdateReason';
import GateList from './pages/master/gate/GateList';
import AddGate from './pages/master/gate/AddGate';
import UpdateGate from './pages/master/gate/UpdateGate';
import PurposeList from './pages/master/purpose/PurposeList';
import AddPurpose from './pages/master/purpose/AddPurpose';
import UpdatePurpose from './pages/master/purpose/UpdatePurpose';
import VisitorList from './pages/visitor/VisitorList';

function App() {
  return (
    <div className="App">
      {/* <Login /> */}
      <Routes>
        <Route path='/login' element={<Login />} />
        <Route element={<ProtectedRoutes />}>
          <Route path='/' element={<Navigate replace to='/dashboard' />} />
          <Route path='/dashboard' element={<SmartOfficeDashboard />} />

          <Route path='/department-list' element={<DepartmentList />} />
          <Route path='/add-department' element={<AddDepartment />} />
          <Route path='/update-department' element={<UpdateDepartment />} />

          <Route path='/designation-list' element={<DesignationList />} />
          <Route path='/add-designation' element={<AddDesignation />} />
          <Route path='/update-designation' element={<UpdateDesigantion />} />

          <Route path='/defect-list' element={<DefectList />} />
          <Route path='/add-defect' element={<AddDefect />} />
          <Route path='/update-defect' element={<UpdateDefect />} />

          <Route path='/reason-list' element={<ReasonList />} />
          <Route path='/add-reason' element={<AddReason />} />
          <Route path='/update-reason' element={<UpdateReason />} />


          <Route path='/purpose-list' element={<PurposeList />} />
          <Route path='/add-purpose' element={<AddPurpose />} />
          <Route path='/update-purpose' element={<UpdatePurpose />} />

          <Route path='/gate-list' element={<GateList />} />
          <Route path='/add-gate' element={<AddGate />} />
          <Route path='/update-gate' element={<UpdateGate />} />

          <Route path='/tooling-configuration' element={<ConfigurationForm />} />
          <Route path='/tooling-configuration-history' element={<ConfigurationHistory />} />

          <Route path='/upload-file' element={<UploadFiles />} />

          <Route path='/user-list' element={<UserList />} />
          <Route path='/add-user' element={<AddUser />} />
          <Route path='/update-user' element={<UpdateUser />} />

          <Route path='/visitor-list' element={<VisitorList />} />

          <Route path='/activity-log' element={<ActivityLogList />} />

          <Route path='/update-version' element={<UpdateVersionForm />} />



        </Route>
      </Routes>

      <ToastContainer />

    </div>
  );
}

export default App;
